<template>
	<div class="row">
		<div class="col-md-6 col-md-offset-3">
			<template v-if="agendamentos !== '' && agendamentos.length > 0">
				<div v-for="a in agendamentos">
					<v-agendamento :agendamento="a" @done="fetchAgendamentos"></v-agendamento>
				</div>
			</template>

			<div class="alert alert-warning" v-else>
				<strong>NÃO HÁ NENHUM AGENDAMENTO.</strong>
			</div>
		</div>
	</div>
</template>

<script>
	import Agenda from 'models/agenda';
	import VAgendamento from './agendamento';

	export default {
		components: { VAgendamento },

		data() {
			return {
				agendamentos: ''
			};
		},

		created() {
			this.fetchAgendamentos();
		},

		methods: {
			async fetchAgendamentos() {
				let agendamentos = await Agenda.getMeusAgendamentos();

				// garante que somente retorna os agendamentos do usuário
				this.agendamentos = agendamentos.filter(a => a.horas.length === 1);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// agendamentos.vue?9c65f76c